import script from "./aide-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./aide-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./aide-drawer.vue?vue&type=style&index=0&id=4b9dab4b&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9dab4b"]])

export default __exports__